"use client";

import React, { useState, useEffect } from "react";
import Head from "next/head";
import ReactGA from "react-ga4";
import styles from "./page.module.css";
import Image from "next/image";
import LoadingEffect from "@/app/components/loading/LoadingEffect";
import SidebarFilter from "@/app/components/filter/SideBarFilter";
import { ProductContainer } from "@/app/components/product/productContainer";
import AdsBlock from "@/app/components/adsBlock/AdsBlock";
import { cleanSearchResults } from "@/utils/searchUtils";
import { ProductEntry } from '@/types/Product';
import HandleClientComponent from './clientComponent';
import LoadMore from "@/app/components/buttonClicks/LoadMore";
import HandleClickHome from "@/app/components/buttonClicks/ClickHome";
import Script from 'next/script';
let productBasicInfoListStatic: any[] = [];
let productDetailInfoListStatic: any[] = [];
let productReviewInfoListStatic: any[] = [];
let review_summaryList: any[] = [];
let productAllInfoList: any[] = [];
let isLoading: boolean = false;
export default function SearchComponent({
  searchTerm,
  searchResult,
  tagList,
  currentPage,
  videoList,
  blogList
}: {
  searchTerm: string;
  searchResult: ProductEntry[];
  tagList: any[];
  currentPage: number;
  videoList: any[];
  blogList: any[];
}) {
  console.log("enter client search page, searchTerm: ", searchTerm);
  //console.log("enter search component, review_summaryList: ", searchResult[0][2]);

  const [isMobile, setIsMobile] = useState(false);
  if (process.env.NODE_ENV === "development") {
    console.log("enter client search page");
    console.log("searchTerm: ", searchTerm);
  }
  ;
  if (searchResult && tagList.length !== 0 && searchResult.length !== 0 && review_summaryList.length == 0) {
    [productAllInfoList, review_summaryList] = cleanSearchResults(searchResult, tagList);
  } else if (searchResult.length === 0) {
    console.log("client search page, no product information found");
  }
  ;

  //console.log("enter productAllInfoList size", productAllInfoList.length);
  if (productAllInfoList.length !== 0) {
    productBasicInfoListStatic = [];
    productDetailInfoListStatic = [];
    productReviewInfoListStatic = [];
    productAllInfoList.slice(0, 6 * currentPage).forEach((productPack: any[]) => {
      productBasicInfoListStatic.push(productPack[0]);
      productDetailInfoListStatic.push(productPack[1]);
      productReviewInfoListStatic.push(productPack[2]);
    });
  } else {
    console.log("productAllInfoList is empty");
  }

  // Detect if the screen size is mobile
  useEffect(() => {
    const handleResize = () => {
      // setIsMobile(window.innerWidth <= 768);
      setIsMobile(window.innerWidth <= 902);
    };
    window.addEventListener('resize', handleResize);

    // Initial check
    handleResize();

    // Cleanup listener on unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return <>
			<head>
                <title>{decodeURIComponent(searchTerm)} - Best Camera Comparisons & Recommendations 2024</title>
				<meta property="og:url" content="https://www.commentlyai.com" data-sentry-element="meta" data-sentry-source-file="searchComponent.tsx" />
				<link rel="icon" href="/favicon.ico" sizes="16x16" type="image/x-icon" />
				<link rel="icon" type="image/png" sizes="16x16" href="/favicon16.png" />
                <link rel="icon" type="image/png" sizes="32x32" href="/favicon32.png" />
                <link rel="icon" type="image/png" sizes="48x48" href="/favicon48.png" />
                <Script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4754629932808889" id="adsbygoogle-script" crossOrigin="anonymous" strategy="lazyOnload" data-sentry-element="Script" data-sentry-source-file="searchComponent.tsx">
				</Script>
			</head>

			<div className={styles.searchPage}>
				<div className={styles.homeContainer}>
					
					<div className={styles.backgroundGradient}>
						<HandleClientComponent searchTerm={searchTerm} searchResult={searchResult} tagList={tagList} productAllInfoList={productAllInfoList} data-sentry-element="HandleClientComponent" data-sentry-source-file="searchComponent.tsx" />

                        <div className="w-full flex flex-row justify-between">
                            <div className={styles.searchHeadlineContiner}>
                                <HandleClickHome data-sentry-element="HandleClickHome" data-sentry-source-file="searchComponent.tsx" />
                                <h1 className={styles.searchTermText}>Search for: {decodeURIComponent(searchTerm)}</h1>
                            </div>

                            {isMobile && <SidebarFilter />}
                        </div>

                        {!isMobile && <SidebarFilter />}

						<ProductContainer productBasicInfoList={productBasicInfoListStatic} review_summaryList={review_summaryList} productDetailInfoList={productDetailInfoListStatic} productReviewInfoList={productReviewInfoListStatic} productAllInfoList={productAllInfoList} tagList={tagList} videoList={videoList} blogList={blogList} data-sentry-element="ProductContainer" data-sentry-source-file="searchComponent.tsx" />

						<AdsBlock data-sentry-element="AdsBlock" data-sentry-source-file="searchComponent.tsx" />

						<LoadMore data-sentry-element="LoadMore" data-sentry-source-file="searchComponent.tsx" />
					</div>
				</div>
			</div>
		</>;
}